import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createReportTemplate, ReportFilter } from "@services/reportEngine";

export type ReportTemplatePayload = {
  name: string;
  dataLevels: string[];
  fields: string[];
  filters: ReportFilter[];
};

export const useCreateReportTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: ReportTemplatePayload) => createReportTemplate(payload),
    { onSuccess: () => queryClient.invalidateQueries(["reportTemplates"]) },
  );
};
